module.exports = __webpack_public_path__ + "img/favicon.bd9b95cb.png";